$(function () {
  $('.js-swatch-option-li.js-swatch-color').on({
    mouseenter: function () {
      const $this = $(this)
      const colorName = swatchToLowerCase(escapeSelector($this.data('value')))

      let materialElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-material:checked').data('unescaped-value'))
      let findImageSelector = `input.sizeColorOption[data-color-option="${colorName}"]`

      if (materialElement && materialElement.indexOf('.') == -1) {
        materialElement = swatchToLowerCase($('input.js-swatch-option-radio.js-swatch-material:checked').val())
        findImageSelector = `${findImageSelector}[data-material-option="${materialElement}"]`
      }

      const variantImage = $(findImageSelector)
      const variantImageSrc = variantImage.attr('data-variant-src')

      if (!variantImage.length) {
        return
      }

      if (variantImageSrc.includes('invalid url input')) {
        return
      }

      $('.js-featured-image-container:first > img.js-variant-image-container')
        .attr('src', variantImageSrc)
        .attr('srcset', variantImage.attr('data-variant-srcset'))
    }
  })

  $('.js-product-grid-container .js-product-top-swatch-label.js-color').on({
    mouseenter: function () {
      const $this = $(this)
      const imageSrc = $this.data('variant-image')
      const imageSrcSet = $this.data('srcset')

      $this
        .closest('.js-product-grid-container')
        .find('a.js-product-grid-image-a > img.js-variant-image-container')
        .attr('src', imageSrc)
        .attr('srcset', imageSrcSet)
    }
  })
})
